import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { client } from '../api/Api';
import { Box, Paper, Typography, TextField, Grid, Button, CircularProgress, Alert } from '@mui/material';

const RecipeAdminEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [recipe, setRecipe] = useState({ title: '', type: '', caloriesKcal: '', instructions: '', imageId: '', productName: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await client.get(`/admin/recipes/${id}`);
        setRecipe({
          title: res.data.title || '',
          type: res.data.type || '',
          caloriesKcal: res.data.caloriesKcal ?? '',
          instructions: res.data.instructions || '',
          imageId: res.data.imageId || '',
          productName: res.data.productName || ''
        });
      } catch (e) {
        setError('Nepavyko užkrauti recepto duomenų');
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRecipe((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      const payload = {
        title: recipe.title,
        type: recipe.type,
        instructions: recipe.instructions,
        imageId: recipe.imageId,
        caloriesKcal: recipe.caloriesKcal === '' ? null : Number(recipe.caloriesKcal)
      };
      await client.put(`/admin/recipes/${id}`, payload);
      setSuccess('Išsaugota sėkmingai');
      setTimeout(() => navigate('/admin/recipes'), 800);
    } catch (e) {
      setError('Nepavyko išsaugoti recepto');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Redaguoti receptą</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary">Produktas</Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>{recipe.productName || '-'}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label="Pavadinimas" name="title" value={recipe.title} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label="Tipas" name="type" value={recipe.type} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label="Kalorijos (kcal)" name="caloriesKcal" value={recipe.caloriesKcal} onChange={handleChange} type="number" fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label="Nuotraukos ID" name="imageId" value={recipe.imageId} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Instrukcijos" name="instructions" value={recipe.instructions} onChange={handleChange} fullWidth multiline minRows={6} />
          </Grid>
        </Grid>
        <Box display="flex" gap={2} mt={3}>
          <Button variant="outlined" onClick={() => navigate('/admin/recipes')}>Atgal</Button>
          <Button variant="contained" onClick={handleSave} disabled={saving}>{saving ? 'Saugoma...' : 'Išsaugoti'}</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default RecipeAdminEdit;
